import React from "react"
import AriaModal from "react-aria-modal"
import L10n from "lib/carrot-l10n"
import Helpers from "utils/Helpers"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import { useDispatch, useSelector } from "react-redux"
import { signOut } from "actions/loginActions"
import { getBenefitStartDate, getBenefitStarted } from "derivedSelectors"
import { getFirstName } from "reducers/userInfo"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const getApplicationNode = () => document.getElementById("body")

const BenefitNotStartedContainer = () => {
  const benefitStarted = useSelector(getBenefitStarted)
  const benefitStartDate = useSelector(getBenefitStartDate)
  const firstName = useSelector(getFirstName)

  return benefitStarted ? null : <BenefitNotStarted benefitStartDate={benefitStartDate} firstName={firstName} />
}

const BenefitNotStarted = ({ benefitStartDate, firstName }) => {
  const dispatch = useDispatch()

  const handleSignOutClick = () => {
    dispatch(signOut())
  }

  return (
    <AriaModal
      getApplicationNode={getApplicationNode}
      verticallyCenter
      titleText="Benefit not started"
      includeDefaultStyles={false}
      scrollDisabled
      focusDialog
      dialogClass="fixed top-0 left-0 w-100 h-100 z-9999 overflow-x-hidden overflow-y-auto flex justify-center items-center bg-modal-dark"
    >
      <div className="mw7 w-100 ph3-ns ph2 center bg-white">
        <div className="ph3-ns ph2">
          <h1 className={`publico-headline b f1 tc mv5-ns mv4 lh-title`}>
            {l("benefitNotStarted.allSet", { memberName: firstName })}
          </h1>
          <p className="f4 tc mv3 lh-copy black-60">
            {l("benefitNotStarted.thanks", {
              benefitStartDate: Helpers.formatDate(benefitStartDate)
            })}
          </p>
          <p className="f4 tc mv3 lh-copy black-60">{l`benefitNotStarted.nextSteps`}</p>
        </div>

        <div className="pa3-ns pa2 flex flex-row-ns flex-column justify-center items-center">
          <div className="dib-ns mv4-ns mv3 pa3-ns pa2">
            <ButtonPrimary onClick={handleSignOutClick}>{l`client.logout`}</ButtonPrimary>
          </div>
        </div>
      </div>
    </AriaModal>
  )
}

export { BenefitNotStartedContainer }
